import type { IconBaseProps } from "./IconBase";
import IconBase from "./IconBase";

export const ScreenshotIcon = (props: IconBaseProps) => {
  return (
    <IconBase {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 15H1V17H3V15ZM3 19H1C1 20.1046 1.89543 21 3 21V19ZM15 3H13V5H15V3ZM23 7H21V9H23V7ZM21 3V5H23C23 4 22 3 21 3ZM9 20C9 20.5523 9.44772 21 10 21H22C22.5523 21 23 20.5523 23 20V12C23 11.4477 22.5523 11 22 11H20L18 9H14L12 11H10C9.44771 11 9 11.4477 9 12V20ZM3 7H1V9H3V7ZM7 19H5V21H7V19ZM19 3H17V5H19V3ZM3 3C2 3 1 4 1 5H3V3ZM3 11H1V13H3V11ZM11 3H9V5H11V3ZM7 3H5V5H7V3ZM20 16C20 18.2091 18.2091 20 16 20C13.7909 20 12 18.2091 12 16C12 13.7909 13.7909 12 16 12C18.2091 12 20 13.7909 20 16ZM16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z"
        fill="currentColor"
      />
    </IconBase>
  );
};

export default ScreenshotIcon;
